import { GetPurchasePromosResponse_Promo } from '@weave/schema-gen-ts/dist/schemas/payments-platform/care-credit-integration/care_credit_integration.pb';
import { i18next } from '@frontend/i18n';
import { FinanceOption, FinanceOptionType } from '../../../types/care-credit.types';

export const MIN_AMOUNT_FOR_OPTIONS = 200;

export const DEFAULT_FINANCE_OPTION_FALLBACK: Pick<FinanceOption, 'id' | 'title' | 'promoCode' | 'description'> = {
  id: '102',
  title: i18next.t('Standard Account Terms', {
    ns: 'payments-care-credit',
  }),
  promoCode: '102',
  description: i18next.t('Standard Account Terms Apply. See Credit Card Agreement for Applicable Terms.', {
    ns: 'payments-care-credit',
  }),
};

export const stripHtmlTags = (str: string) => str.replace(/<\/?[^>]+(>|$)/g, '');

export const getFinanceOptionType = (promo: GetPurchasePromosResponse_Promo): FinanceOptionType => {
  if (promo.type === 'DFFR') {
    return 'deferred_interest';
  } else if (promo.type === 'EEP') {
    return 'reduced_apr';
  } else {
    return 'unknown';
  }
};
